export default {
      id: "following_non_login-usage",
      viewBox: "0 0 164 161",
      url: "/" + "images/icons.3.109.2.svg#following_non_login-usage",
      toString: function () {
        return this.url;
      }
    }